import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Product } from '../types/product.type';
import { PricingService } from './pricing.service';
import { StoryblokService } from './storyblok.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private storyblokService: StoryblokService, private pricingService: PricingService) {}

  public async getAllProducts(): Promise<Product[]> {
    const [products, prices] = await Promise.all([
      lastValueFrom(this.storyblokService.getStories({ content_type: 'PricingTechnicalLink' })),
      this.pricingService.getPrices('main'),
    ]);
    return products.map(product => this.convertProduct(product, prices)).filter(Boolean);
  }

  private convertProduct(productLink: any, backendPrices: any[]): Product {
    const prices = backendPrices
      .filter(price => {
        return (
          productLink.content.lookupKeyMonthly === price.lookup_key ||
          productLink.content.lookupKeyYearly === price.lookup_key
        );
      })
      .map(price => this.pricingService.convertPrice(price));

    const product: Product = {
      id: prices[0].product,
      storyblokLinkId: productLink.uuid,
      name: productLink.name,
      color: productLink.content.color,
      prices,
      isFree: !!prices.find(price => ['free_yearly', 'free_monthly'].includes(price.lookupKey)),
    };
    return product;
  }

  public async getDefaultProducts() {
    const [allProducts, defaultProducts] = await Promise.all([this.getAllProducts(), this.getDefaultProductList()]);

    return defaultProducts.map(id => allProducts.find(p => p.storyblokLinkId === id)).filter(Boolean);
  }

  private async getDefaultProductList(): Promise<string[]> {
    const resp = await lastValueFrom(this.storyblokService.getStory('technical/default-products'));
    return resp.story.content.products;
  }
}
